import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfViewerComponent } from '@shared/pdf-viewer/pdf-viewer/pdf-viewer.component';
import { BtnLoaderModule } from '@ux/components/btn-loader/btn-loader.module';

@NgModule({
  declarations: [PdfViewerComponent],
  imports: [
    CommonModule,
    BtnLoaderModule
  ],
  exports: [
    PdfViewerComponent
  ]
})
export class PdfViewerModule { }
